import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { lookups, lookupsType, nationalCentersOption } from '../../libs/services';

var Config = require('../../config');
class PatientData extends Component{

    constructor(props, context) {
		super(props, context);
        this.getNationalCenters = this.getNationalCenters.bind(this);
		this.setNationalCenter = this.setNationalCenter.bind(this);

        this.state = {
            national_centers:[],
			relationships:[],
			rhGroup:[],
			emergency_levels:[]
		};
	}

    async componentDidMount(){
		this.props.onRef(this);
        await this.getNationalCenters();

		var response = await lookups('FAMILIAR_RELATIONSHIP', 'false');
		if(response !== undefined){
			this.setState({
				relationships: response
			});
		}
		
		response = await lookupsType('blood_group_rh');
		if(response !== undefined){
			this.setState({
				rhGroup: response
			});
		}
		
		response = await lookups('PATIENT_EMERGENCY_LEVEL', 'false');
		if(response !== undefined){
			this.setState({
				emergency_levels: response
			});
		}
    }

	setNationalCenter(center){
    	for (var i = 0; i < this.state.national_centers.length; i++) {
			if (this.state.national_centers[i].id === center) {
				this.setState({
					indice:i,
					national_center: [this.state.national_centers[i]],
				});
				break;
			}
		}	
    }

    handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	this.setState({
				indice:0,
				national_center:values,
		    });
        	this.props.autocompleteHandle(name,values[0].id);

        }else if(this.state.national_center.length > 0){
        	this.setState({
				national_center:[]
		    });
        }
	}

    async getNationalCenters(){
		var response = await nationalCentersOption(sessionStorage.getItem("health_facilities_id"), 'origin_patients');
		if(response !== undefined){
			this.setState({
				national_centers: response
			});
  
			if(this.props.state.national_center_id !== ""){
				this.setNationalCenter(this.props.state.national_center_id);
			}
		}
		
	}

	//seleccion de grupo y rh
	rhGroupHandleChange = (event) => {
		for(var i=0; i < this.state.rhGroup.length;i++){
			if(this.state.rhGroup[i].name === event.target.value){
				this.props.autocompleteHandle('lookup_group',this.state.rhGroup[i].key_group);
				this.props.autocompleteHandle('lookup_rh',this.state.rhGroup[i].key_rh);
			}
		}
		this.props.selectFieldHandle("id","lookup_value",event);
	}

	// setNationalCenter(center){
    // 	for (var i = 0; i < this.state.national_centers.length; i++) {
	// 		if (this.state.national_centers[i].id === center) {
	// 			this.setState({
	// 				indice:i,
	// 				requestedSelected: [this.state.national_centers[i]],
	// 			});
	// 			break;
	// 		}
	// 	}	
    // }

    render(){
        const { t } = this.props;
        return(
            <div className="col-xs-12" style={{padding:"0px"}}>
				<div className="col-xs-12 col-md-4" >
					<span className="span-min">{t('content.offers.form.names')}</span>
					<input className="form-control input_data_donor" name="patient_name" id="patient_name" 
						disabled={this.state.disablePatient} onKeyPress={(e) => this.props.validate(e)}
						value={ this.props.state.patient_name } onChange={ this.props.handleChange }
					/>
				</div>
				<div className="col-xs-12 col-md-2" >
					<span className="span-min">{t('content.offers.form.lastname1')}</span>
					<input className="form-control input_data_donor" name="patient_lastname1" id="patient_lastname1"
						disabled={this.state.disablePatient}
						value={ this.props.state.patient_lastname1 } onKeyPress={(e) => this.props.validate(e)}
						onChange={ this.props.handleChange }/>
				</div>
				{this.props.showField("patient", "lastname2")?
					<div className="col-xs-12 col-md-2" >
						<span className="span-min">{t('content.offers.form.lastname2')}</span>
						<input className="form-control input_data_donor" name="patient_lastname2" id="patient_lastname2"
							onKeyPress={(e) => this.props.validate(e)}
							disabled={this.state.disablePatient}
							value={ this.props.state.patient_lastname2 } onChange={ this.props.handleChange } 
						/>
					</div>
				:null}

				{this.props.showField("patient", "gender")?
					<div className="col-xs-12 col-sm-2" >
						<span className="span-min">{t('content.offers.form.gender')}</span>
						<select className="form-control" id="patient_sex" name="patient_sex" 
							onKeyPress={(e) => this.props.validate(e)} disabled={this.state.disablePatient}
							value={this.props.state.patient_sex} onChange={this.props.handleChange} > 
							<option value="" >Seleccionar...</option>
							<option value="HOMBRE" >HOMBRE</option>
							<option value="MUJER" >MUJER</option>
						</select>
					</div>
				:null}
				
				{this.props.showField("patient", "birthday")?
					<div className="col-xs-12 col-md-2" >
						<span className="span-min">{t('content.offers.form.birthday')}</span>
						<MaskedFormControl type='text' name="patient_birthday" id="patient_birthday" 
							value={this.props.state.patient_birthday} disabled={this.state.disablePatient}
							onChange={this.props.dateHandleChange} onKeyPress={(e) => this.props.validate(e)}
							mask='11/11/1111' placeholder="dd/mm/yyyy" className="form-control input-date" />
					</div>
				:null}

				{this.props.showField("patient", "health_facility")?
					<div className="col-xs-12 col-sm-4">
						<div>
							<span className="span-min">{t('content.offers.form.health_facility')}</span>
						</div>
						<div style={{width:this.state.user_add_center === 'YES' ? '90%' : '100%', display:'inline-block'}}>
							<AsyncTypeahead 
								/*{...this.state}*/
								labelKey={(option) => `${option.name}`}
								minLength={0}
								disabled={this.state.disablePatient} 
								onKeyPress={(e) => this.props.validate(e)}
								options={this.state.national_centers}
								onChange={this.handleTypeAheadChange('national_center_id')}
								onSearch={this._handleSearchNC}
								inputProps={{
									name:"national_center_id",
									id:"national_center_id"
								}}
								id="nationalCenterId"
								defaultSelected={this.state.national_centers.slice(this.state.indice, 1)}
									selected={this.state.national_center}
								r
								ef="_handleSearch_nc"
								className="input_data_donor"
								useCache={false}
								isLoading={this.state.isLoading}
								delay={600}
							/>
						</div>
					</div>
				:null}

				{this.props.showField("patient", "service")?
					<div className="col-xs-12 col-sm-4">
						<span className="span-min">{t('content.offers.form.service')}</span>
						<input className="form-control" name="national_name" id="national_name" onKeyPress={(e) => this.props.validate(e)}
							value={ this.props.state.national_name } 
							disabled={this.state.disablePatient} 
							onChange={ this.props.handleChange }/>
					</div>
				:null}
					
				{this.props.showField("patient", "relationship")?
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">{t('content.offers.form.relationship')}</span>
						<select className="form-control input_data_donor" name="relationship" id="relationship" 
							value={ this.props.state.relationship } 
							disabled={this.state.disablePatient} 
							onChange={ this.props.selectFieldHandle.bind(null,"id","relationship") } onKeyPress={(e) => this.props.validate(e)}> 
							<option value="" disabled>Seleccionar...</option>
							{
								this.state.relationships.map(function(t) {
									return <option key={t.id}  value={t.key} >{t.name} </option>;
								})
							}
						</select>
					</div>
				:null}
				
				{this.props.showField("patient", "social_number")?
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">No. IMSS</span>
						<input className="form-control input_data_donor" name="social_number" 
							id="social_number" onKeyPress={(e) => this.props.validate(e)}
							value={ this.props.state.social_number || "" } 
							onChange={ this.props.handleChange }/>
					</div>
				:null}

				{/*this.props.showField("patient", "expedient")?
					<div className="col-xs-12 col-md-2" >
						<span className="span-min">{t('content.offers.form.no_file')}</span>
						<input className="form-control input_data_donor" name="no_file" id="no_file" value={ this.props.state.no_file || "" } 
							onChange={ this.props.handleChange } 
							onKeyPress={(e) => this.props.validate(e)}/>
					</div>
						:null*/}

				{this.props.showField("patient", "group_rh")?
					<div className="col-xs-12 col-md-2" >
						<span className="span-min">{t('content.offers.form.rh_group')}</span>
						
						<select className="form-control input_data_donor" name="rh_group" id="rh_group" 
								value={ this.props.state.rh_group ||""} onKeyPress={(e) => this.props.validate(e)}
								onChange={ this.rhGroupHandleChange.bind(this) } > 
							<option value="">Seleccionar...</option>
							{
								this.state.rhGroup.map(function(t,index) {
								return <option key={index}  value={t.name} >{t.name} </option>;
								})
							}
						</select>
					</div>
				:null}

				{this.props.showField("patient", "emergency_level")?
					<div className="col-xs-12 col-md-2" >
						<span className="span-min">Nivel de urgencia</span>
						<select className="form-control" name="emergency_level" id="emergency_level" 
							value={this.props.state.emergency_level || ""} onChange={this.props.handleChange}>
							<option value="">Seleccione...</option>
							{this.state.emergency_levels.map((e, i)=>(
								<option key={i} value={e.key}>{e.name}</option>
							))}
						</select>
					</div>
				:null}
				{/*this.props.showField("patient", "number")?
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Número de Paciente</span>
						<input className="form-control hour-input" 
							name="patient_number" id="patient_number"
							disabled={this.state.pac_usr_npm === 'NO'}
							value={this.props.state.patient_number} onChange={(e)=>this.props.handleChange(e)} />
					</div>
							:null*/}
			</div>	
        );
    }
}

export default translate('translations')(PatientData);